import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PATHS } from '../../common/constants';
import AddressInformation from '../../components/AddressCard';
import Avatar from '../../components/Avatar';
import Breadcrumb from '../../components/Breadcrumb';
import KeyContactCard from '../../components/KeyContactCard';
import Details from '../../components/Details';
import ReusableLightbox from 'src/components/ReusableLightbox/reusable-lightbox';
import '../Contact/ContactDetails.scss';

class KeyContactDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  state = {
    showOverlay: false,
    isOpen: false,
  };

  render() {
    const { keyContact } = this.props;
    const { isOpen } = this.state;
    return (
      <div className="contact-details">
        <div className="contact-details__top">
          <div className="contact-details__breadcrumb">
            <Breadcrumb label="Key Contacts" to={PATHS.KEY_CONTACTS_LIST} />
          </div>
        </div>
        <div className="contact-details__bottom">
          <Details
            items={[
              <div
                onClick={() =>
                  this.setState({
                    isOpen:
                      keyContact && keyContact.profileImage ? true : false,
                  })
                }
              >
                <div className="contact-details__tenant">
                  <div className="contact-details__avatar">
                    <Avatar size="large" url={keyContact.profileImage} />
                    {isOpen && isOpen === true ? (
                      <ReusableLightbox
                        isOpen={isOpen}
                        onClose={() => this.setState({ isOpen: false })}
                        image={keyContact.profileImage}
                      />
                    ) : null}
                  </div>
                  <div className="contact-details__name">{keyContact.name}</div>
                  <div className="contact-details__type"></div>
                </div>
              </div>,
              <KeyContactCard contact={keyContact} />,
              keyContact &&
                keyContact.address &&
                Object.keys(keyContact.address) && (
                  <AddressInformation contact={keyContact} />
                ),
            ]}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(KeyContactDetails);
